module.exports = __webpack_public_path__ + "img/heart.ed961594.svg";